import { Link } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { HealthBadge } from '@/components/HealthBadge';
import { api } from '@/api/client';

export function TopBar() {
  async function logout() {
    await api('/api/auth/logout', { method: 'POST' });
    window.location.href = '/login';
  }

  return (
    <header
      style={{
        display: 'flex',
        height: 56,
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        background: '#fff',
        borderBottom: '1px solid #e2e8f0',
      }}
    >
      <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 16, fontWeight: 600 }}>LiteLLM Console</span>
      </Link>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <HealthBadge />
        <Button variant="ghost" size="sm" onClick={logout}>
          <LogOut size={16} />
          <span>Logout</span>
        </Button>
      </div>
    </header>
  );
}
